import AutocompleteField from './AutocompleteField'

import fillAddress from './fillAddress'
import getAddress from './getAddress'
import useAddress from './useAddress'

export {fillAddress, getAddress, useAddress}

export default AutocompleteField
